import {ChangeDetectionStrategy, Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LoginPageLang, UtilsService} from '../../../shared';

@Component({
    selector: 'sl-anonymous-login',
    templateUrl: './anonymous-login.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnonymousLoginComponent extends LoginPageLang {
    public readonly redirectRoute: string = '/produkte/identifikation';

    constructor(private translateService: TranslateService,
                private utilsService: UtilsService) {
        super();
    }
}
